import Client from './EditClient';

export default Client;
